module.exports = __webpack_public_path__ + "img/eoccsr.25e3d5bb.png";